var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7077 9.74592C22.7 8.91292 22.3643 8.11651 21.7735 7.52925L14.981 0.720921C14.6844 0.426023 14.2831 0.260499 13.8648 0.260499C13.4465 0.260499 13.0452 0.426023 12.7485 0.720921C12.6001 0.868112 12.4823 1.04323 12.4019 1.23617C12.3216 1.42912 12.2802 1.63607 12.2802 1.84509C12.2802 2.05411 12.3216 2.26106 12.4019 2.454C12.4823 2.64694 12.6001 2.82206 12.7485 2.96925L17.9577 8.16259L2.12435 8.16259C1.70442 8.16259 1.3017 8.3294 1.00476 8.62633C0.707831 8.92327 0.541015 9.32599 0.541015 9.74592C0.541015 10.1658 0.707831 10.5686 1.00476 10.8655C1.3017 11.1624 1.70442 11.3293 2.12435 11.3293L17.9577 11.3293L12.7485 16.5384C12.4504 16.8345 12.282 17.2368 12.2806 17.657C12.2791 18.0771 12.4446 18.4807 12.7406 18.7788C13.0366 19.077 13.439 19.2453 13.8592 19.2468C14.2793 19.2483 14.6829 19.0828 14.981 18.7868L21.7735 11.9784C22.3682 11.3873 22.7041 10.5844 22.7077 9.74592Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.1d048c4b8b9fc82164230586018056cd.svg";
export { ForwardRef as ReactComponent };